/**
 * vuex typings
 */
export const TEST_MODULE = {
  ACTIONS: 'ACTIONS',
}
